import React from 'react';
export function Header() {
  return <header className="text-center mb-8" data-id="element-78">
      <div className="flex justify-center mb-4" data-id="element-79">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sUePpV1ZiVR8xK3DA3C5CD/IMG_0740.png" alt="GreenHS Logo" className="h-20 w-auto object-contain" data-id="element-80" />
      </div>
      <h1 className="text-3xl md:text-4xl font-bold mb-2 text-gray-900 relative inline-block" data-id="element-81">
        Subscribe to GreenHS VIP
        <span className="absolute -inset-1 bg-yellow-400/20 blur-sm rounded-full" data-id="element-82"></span>
      </h1>
      <p className="text-lg text-gray-700 max-w-xl mx-auto" data-id="element-83">
        Get daily accurate 2–5 odds tickets posted directly to the VIP channel!
      </p>
    </header>;
}